import { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const c = localStorage.getItem("ecs_cookie_consent");
    if (!c) setShow(true);
  }, []);

  const persist = (a, m) => {
    localStorage.setItem("ecs_cookie_consent", JSON.stringify({
      necessary: true, analytics: a, marketing: m, at: new Date().toISOString(),
    }));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-50" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto glass rounded-2xl p-5 md:p-6 shadow-card relative">
        <button
          onClick={() => persist(false, false)}
          className="absolute top-3 right-3 p-1 rounded-md hover:bg-white/10 text-muted2 hover:text-ink-900"
          aria-label="Fermer"
          data-testid="cookie-close"
        ><X className="w-4 h-4" /></button>
        <h3 className="font-display text-gold-700 text-lg mb-1">Vos cookies, vos règles 🍪</h3>
        <p className="text-sm text-muted2 mb-4 leading-relaxed">
          On utilise des cookies pour faire fonctionner le site (obligatoires) et — si vous le souhaitez —
          pour mesurer l'audience ou personnaliser nos communications. À vous de choisir.
        </p>
        <div className="grid md:grid-cols-3 gap-3 mb-4 text-sm">
          <div className="px-3 py-2 rounded-md border border-gold-200 flex items-center justify-between">
            <span>Nécessaires</span>
            <span className="font-mono text-xs text-success">obligatoire</span>
          </div>
          <label className="px-3 py-2 rounded-md border border-gold-200 flex items-center justify-between cursor-pointer">
            <span>Analytics</span>
            <input type="checkbox" checked={analytics} onChange={(e)=>setAnalytics(e.target.checked)} data-testid="consent-analytics" />
          </label>
          <label className="px-3 py-2 rounded-md border border-gold-200 flex items-center justify-between cursor-pointer">
            <span>Marketing</span>
            <input type="checkbox" checked={marketing} onChange={(e)=>setMarketing(e.target.checked)} data-testid="consent-marketing" />
          </label>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            onClick={()=>persist(false,false)}
            className="px-4 py-2 text-sm rounded-md border border-ink-200 hover:bg-white/5"
            data-testid="cookie-reject-all"
          >Tout refuser</button>
          <button
            onClick={()=>persist(analytics,marketing)}
            className="px-4 py-2 text-sm rounded-md border border-gold-300 hover:bg-gold-500/10 text-gold-700"
            data-testid="cookie-save"
          >Enregistrer mes choix</button>
          <button
            onClick={()=>persist(true,true)}
            className="px-4 py-2 text-sm rounded-md bg-gold-500 text-ink-900 font-medium hover:bg-gold-500-400 flex-1"
            data-testid="cookie-accept-all"
          >Tout accepter</button>
        </div>
      </div>
    </div>
  );
}
